import {
  GOOGLE_ANALYTIC_COOKIE,
  TYPESENSE_COOKIE,
  UTM_SOURCE_COOKIE,
  CUSTOMER_ID_COOKIE,
  VUESTOREFRONT_COOKIE,
} from '~~/constants/cookies';
import { BLOOMREACH_COOKIE } from '~~/constants/bloomreach';

const useCookies = () => {

  const country = useCookie(VUESTOREFRONT_COOKIE.COUNTRY);
  const languageAndCountry = useCookie(VUESTOREFRONT_COOKIE.LOCALE);
  const googleUserToken = useCookie(GOOGLE_ANALYTIC_COOKIE);
  const typesenseUserToken = useCookie(TYPESENSE_COOKIE);
  const bloomreachCookie = useCookie(BLOOMREACH_COOKIE);
  const utmSourceCookie = useCookie(UTM_SOURCE_COOKIE);
  const customerIdCookie = useCookie(CUSTOMER_ID_COOKIE);
  const addBloomreachCookieChangeListener = () => {
    // universalCookies.addChangeListener((cookie) => {
    //   if (cookie.name === BLOOMREACH_COOKIE) {
    //     bloomreachCookie.value = cookie.value;
    //   }
    // });
  };
  const setUtmSourceCookie = (value: string) => {

    if (value.length > 0) {

      utmSourceCookie.value = value;

    }

  };

  const setCustomerIdCookie = (customerId: string | undefined) => {

    customerIdCookie.value = customerId;

  };

  return {
    country,
    languageAndCountry,
    googleUserToken,
    typesenseUserToken,
    bloomreachCookie,
    utmSourceCookie,
    customerIdCookie,
    setUtmSourceCookie,
    setCustomerIdCookie,
    addBloomreachCookieChangeListener,
  };

};

export default useCookies;
